import React from 'react';
import PageHero from 'components/PageHero';
import iconRightArrow from 'assets/images/icon-arrow-right.svg';
import heroIllustration from 'assets/images/hero-studio-cassolato.svg';
import aboutImg1 from 'assets/images/about-img-1.png';
import aboutImg2 from 'assets/images/about-img-2.png';


let Homepage = () => {



    return (
        <>
            <PageHero
                eyebrow="Enterprise software & consulting"
                title={<>Studio<br />Cassolato</>}
                lead="Progettiamo percorsi di innovazione digitale in base alle specifiche esigenze organizzative e strategiche delle aziende, con l’obiettivo di rendere le loro infrastrutture tecnologiche più performanti, sicure, scalabili e flessibili."
                visual={heroIllustration}
                visualAlt="Illustrazione di persone, processi e software collegati da un percorso"
                visualFit="illustration"
                primaryCta={{ href: '/contacts', label: 'Contattaci' }}
                secondaryCta={{ href: '/solutions', label: 'Scopri i nostri servizi' }}
            />

            <div id="introSection" className="intro-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 about-content">
                            <h2>Attraverso lo sviluppo di <span className="hightlight-color">soluzioni software custom-designed</span>, aiutiamo i nostri clienti a ottimizzare i processi aziendali, consolidare il loro business e cogliere nuove opportunità di mercato.</h2>
                                 <a href="/solutions" className="default-btn btn-outline default-transition">Scopri i nostri servizi<img src={iconRightArrow} alt="" /></a>
                                 
                        </div>
                        <div className="col-md-6 about-img">
                            <div className="about-img_one">
                                <img src={aboutImg1} alt="" />
                                    <div className="about-img_two">
                                        <img src={aboutImg2} alt="" />
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Homepage;
